(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("uuid/v4"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "uuid/v4"], factory);
	else if(typeof exports === 'object')
		exports["select"] = factory(require("react"), require("prop-types"), require("uuid/v4"));
	else
		root["select"] = factory(root["React"], root["PropTypes"], root["uuid"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition